export const WORKFLOW_STATUS = {
  processing: 'processing',
  awaiting_input: 'awaiting_input',
  awaiting_client_input: 'awaiting_client_input',
  approved: 'approved',
  declined: 'declined',
  review: 'review',
  abandoned: 'abandoned',
  error: 'error',
} as const

type WorkFlowStatus = (typeof WORKFLOW_STATUS)[keyof typeof WORKFLOW_STATUS]

export type KycCheckRun = {
  type: 'kyc-check-runs'
  id: number
  attributes: {
    kycApplicantId: string
    externalOnfidoWorkflowId: string
    externalOnfidoWorkflowRunId: string
    status: WorkFlowStatus
    considers: string[]
    createdAt: Date
    updatedAt: Date
  }
}
